var exports = {
  "kL": "xa15a2ab7--7e01a4--container",
  "ZZ": "xa15a2ab7--7e01a4--field",
  "QZ": "xa15a2ab7--7e01a4--sms-code",
  "nn": "xa15a2ab7--7e01a4--buttons-wrap",
  "AP": "xa15a2ab7--7e01a4--seconds-left",
  "Eu": "xa15a2ab7--7e01a4--send-code-again",
};

module.exports = exports;
